import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {SocialLoginService} from "../../shared/service/social-login.service";
import {UserService} from "../../shared/service/user.service";
import * as _ from 'lodash';
import {NavController} from "@ionic/angular";
import {CommonService} from "../../shared/service/common.service";
import {UserProfileFormComponent} from "../../shared/components/user-profile-form/user-profile-form.component";
import {NavigationService} from "../../shared/service/navigation.service";

@Component({
  selector: 'app-register-social',
  templateUrl: './register-social.page.html',
  styleUrls: ['./register-social.page.scss'],
})
export class RegisterSocialPage implements OnInit, AfterViewInit {

  @ViewChild("appUserProfile") appUserProfile: UserProfileFormComponent;

  registerProgress: boolean;
  policyAccepted: boolean;

  constructor(private userService: UserService,
              private navigationService: NavigationService,
              private navController: NavController,
              private commonService: CommonService,
              private socialLoginService: SocialLoginService) {
  }

  ngAfterViewInit(): void {
    this.appUserProfile.registerForm.patchValue(this.socialLoginService.partialUserInfo);
  }

  ngOnInit() {
  }

  onViewPolicy() {
      this.navigationService.forwardModal('policy');
  }

  onRegister() {

    if (!this.policyAccepted) {
      this.commonService.presentAlertMsg('Policy di registrazione', 'Per completare la registrazione, è necessario accettare i Termini di Servizio e l\'Informativa sulla Privacy.');
      return;
    }

    const finalRequest = _.merge(this.socialLoginService.partialUserInfo, this.appUserProfile.registerForm.value);
    finalRequest['registration'] = true;

    //Invoco l'api di registrazione social
    this.registerProgress = true;
    this.userService.registerSocial(finalRequest).subscribe(() => {

      this.socialLoginService.reset();
      this.registerProgress = false;
      this.navigationService.closeModal();

      if(this.navigationService.navigationAfterLogin){
        this.navigationService.useNavigationAfterLogin()
      } else {
        this.navController.navigateRoot(['/tabs/home']);
      }

    }, (error) => {

      this.registerProgress = false;

      if (error?.status == 400) {
        this.commonService.presentAlertMsg("Error occured", 'APP_ERRORS.' + error?.error?.message);
      } else {
        this.commonService.presentAlertMsg("Error occured", 'Errore generico');
      }

    });

  }

}
